import React, { FC } from 'react'
import Select from 'react-select'

import { IInputProps } from '../../../modules/form'
import { isEqual  } from '../../../modules/utils';

interface IAsyncDataConfig {
    pathLabel: string,
    pathValue: string,
    response: any,
}

interface IInputSelect extends IInputProps {
    options?: any,
    isClearable?: boolean,
    asyncData?: IAsyncDataConfig,
    placeholder?: string,
    isMulti?: boolean
}

const CustomOption = (props: any) => {
    const { data, innerRef, innerProps, isSelected } = props;
    return <div ref={innerRef} {...innerProps} className={`user-select px-2 py-1 ${isSelected ? 'active' : ''}`}>
        <div className={`user-select-title ${isSelected ? 'active' : ''}`}>
            {data.label}
        </div>
        <div className={`user-select-email ${isSelected ? 'active' : ''}`}>
            {data.value}
        </div>
    </div>
};

export const UserSelect: FC<IInputSelect> = (props) => {

    const generalProps = {
        className: 'InputSelect',
        classNamePrefix: 'InputSelect',
        isSearchable: true,
        placeholder: props.placeholder || '-- Select --',
        onChange: (data: any) => props.onChange(data),
        defaultValue: props.defaultValue,
        onBlur: () => props.onTouched(),
        isClearable: typeof props.isClearable === 'boolean' ? props.isClearable : true,
        isDisabled: props.isDisabled,
        isMulti: props.isMulti || false
    }

    return (
        <Select
            {...generalProps}
            options={props.options}
            value={props.isMulti ? props.value : props.value ? props.options.find((v: any) => isEqual(props.value, v.value)) : ''}
            components={{ Option: CustomOption }}
        />
    )
}